module.exports = __webpack_public_path__ + "static/img/4895_phase_function_Paper_Points.fcd40ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4895_phase_function_Paper_Points.png
// module id = qtNx
// module chunks = 0